import api from './api';

export const getResourceById = async (id) => {
    // This endpoint might not exist in backend yet if it's purely frontend data 
    // BUT ResourceDetails.jsx uses trendingResources static data for details
    // and only API for progress.
    // So we only need progress related endpoints here for now.
    // If there is a backend for resources verify it.
    // Based on ResourceDetails.jsx:
    // const res = await axios.get(`${API_URL}/api/resources/${resourceId}/progress`...
    // const res = await axios.post(`${API_URL}/api/resources/${id}/progress`...
    return;
};

export const getResourceProgress = async (resourceId) => {
    const response = await api.get(`/api/resources/${resourceId}/progress`);
    return response.data;
};

export const updateResourceProgress = async (resourceId, data) => {
    const response = await api.post(`/api/resources/${resourceId}/progress`, data);
    return response.data;
};
